import { Injectable } from '@angular/core';
import { Store, StoreConfig } from '@datorama/akita';
import { UntilDestroy } from '@ngneat/until-destroy';
import { DataLineageDiagramState } from './data-lineage-diagram.model';

const initialState: DataLineageDiagramState = {
  activeNode: null,
  dataLoading: false,
  searchNodes: [],
  inputModel: null,
  outputModel: null,
  filters: [],
  highlights: [],
};

@UntilDestroy()
@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'data-lineage-diagram' })
export class DataLineageDiagramStore extends Store<DataLineageDiagramState> {
  constructor() {
    super(initialState);
  }
}
